import AppHeader from "@/components/AppHeader";

export default {
  name: "user-new",
  components: {
    AppHeader
  },
  async created() {
    await this.getUser();
    this.getTodayDate();
    this.getCompany();
    this.getDepartment();
    this.getPosition();
    this.birthDayCount = new Date(this.birthYear, this.birthMonth, 0).getDate();
  },
  data() {
    return {
      user: {
        last_name: "",
        first_name: "",
        last_name_kana: "",
        first_name_kana: "",
        login_id: "",
        company_id: "",
        department_id: "",
        position_id: "",
        authority: "",
        join_day: "",
        gender: "",
        birth_day: "",
        postal_first: "",
        postal_last: "",
        address: "",
        tel_first: "",
        tel_middle: "",
        tel_last: "",
        sub_tel_first: "",
        sub_tel_middle: "",
        sub_tel_last: "",
        email: "",
        paid_holiday_count: "",
        license_content: "",
        content: "",
        tkc_user_no: "",
        hourly_wage: "",
        emergency1_last_name: "",
        emergency1_first_name: "",
        emergency1_last_name_kana: "",
        emergency1_first_name_kana: "",
        emergency1_postal_first: "",
        emergency1_postal_last: "",
        emergency1_address: "",
        emergency1_tel_first: "",
        emergency1_tel_middle: "",
        emergency1_tel_last: "",
        emergency1_sub_tel_first: "",
        emergency1_sub_tel_middle: "",
        emergency1_sub_tel_last: "",
        emergency1_relationship: "",
        emergency2_last_name: "",
        emergency2_first_name: "",
        emergency2_last_name_kana: "",
        emergency2_first_name_kana: "",
        emergency2_postal_first: "",
        emergency2_postal_last: "",
        emergency2_address: "",
        emergency2_tel_first: "",
        emergency2_tel_middle: "",
        emergency2_tel_last: "",
        emergency2_sub_tel_first: "",
        emergency2_sub_tel_middle: "",
        emergency2_sub_tel_last: "",
        emergency2_relationship: "",
        password: ""
      },
      companies: "",
      positions: "",
      departments: "",
      getUserEnd: false,
      getCompanisEnd: false,
      getDepartmentsEnd: false,
      getPositionsEnd: false,
      joinYear: "",
      joinMonth: "",
      joinDay: "",
      dayCount: "",
      canChoiceYears: [],
      birthYear: "",
      birthMonth: "",
      birthDay: "",
      birthDayCount: "",
      canChoiceBirthYears: []
    };
  },
  computed: {
    joinDayFormat() {
      return this.joinYear + "-" + this.joinMonth + "-" + this.joinDay;
    },
    birthDayFormat() {
      return this.birthYear + "-" + this.birthMonth + "-" + this.birthDay;
    }
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user.last_name = res.user.last_name;
      this.user.first_name = res.user.first_name;
      this.user.last_name_kana = res.user.last_name_kana;
      this.user.first_name_kana = res.user.first_name_kana;
      this.user.login_id = res.user.login_id;
      this.user.company_id = res.user.company_id;
      this.user.department_id = res.user.department_id;
      this.user.position_id = res.user.position_id;
      this.user.authority = res.user.authority;
      this.joinYear = parseInt(res.user.join_day.substr(0, 4));
      this.joinMonth = parseInt(res.user.join_day.substr(5, 2));
      this.joinDay = parseInt(res.user.join_day.substr(8, 2));
      this.user.gender = res.user.gender;
      this.birthYear = parseInt(res.user.birth_day.substr(0, 4));
      this.birthMonth = parseInt(res.user.birth_day.substr(5, 2));
      this.birthDay = parseInt(res.user.birth_day.substr(8, 2));
      this.user.postal_first = res.user.postal_first;
      this.user.postal_last = res.user.postal_last;
      this.user.address = res.user.address;
      this.user.tel_first = res.user.tel_first;
      this.user.tel_middle = res.user.tel_middle;
      this.user.tel_last = res.user.tel_last;
      this.user.sub_tel_first = res.user.sub_tel_first;
      this.user.sub_tel_middle = res.user.sub_tel_middle;
      this.user.sub_tel_last = res.user.sub_tel_last;
      this.user.email = res.user.email;
      this.user.paid_holiday_count = res.user.paid_holiday_count;
      this.user.license_content = res.user.license_content
        ? res.user.license_content
        : "";
      this.user.content = res.user.content ? res.user.content : "";
      this.user.tkc_user_no = res.user.tkc_user_no;
      this.user.hourly_wage = res.user.hourly_wage;
      this.user.emergency1_last_name = res.user.emergency1_last_name;
      this.user.emergency1_first_name = res.user.emergency1_first_name;
      this.user.emergency1_last_name_kana = res.user.emergency1_last_name_kana;
      this.user.emergency1_first_name_kana =
        res.user.emergency1_first_name_kana;
      this.user.emergency1_postal_first = res.user.emergency1_postal_first;
      this.user.emergency1_postal_last = res.user.emergency1_postal_last;
      this.user.emergency1_address = res.user.emergency1_address;
      this.user.emergency1_tel_first = res.user.emergency1_tel_first;
      this.user.emergency1_tel_middle = res.user.emergency1_tel_middle;
      this.user.emergency1_tel_last = res.user.emergency1_tel_last;
      this.user.emergency1_sub_tel_first = res.user.emergency1_sub_tel_first;
      this.user.emergency1_sub_tel_middle = res.user.emergency1_sub_tel_middle;
      this.user.emergency1_sub_tel_last = res.user.emergency1_sub_tel_last;
      this.user.emergency1_relationship = res.user.emergency1_relationship;
      this.user.emergency2_last_name = res.user.emergency2_last_name;
      this.user.emergency2_first_name = res.user.emergency2_first_name;
      this.user.emergency2_last_name_kana = res.user.emergency2_last_name_kana;
      this.user.emergency2_first_name_kana =
        res.user.emergency2_first_name_kana;
      this.user.emergency2_postal_first = res.user.emergency2_postal_first;
      this.user.emergency2_postal_last = res.user.emergency2_postal_last;
      this.user.emergency2_address = res.user.emergency2_address;
      this.user.emergency2_tel_first = res.user.emergency2_tel_first;
      this.user.emergency2_tel_middle = res.user.emergency2_tel_middle;
      this.user.emergency2_tel_last = res.user.emergency2_tel_last;
      this.user.emergency2_sub_tel_first = res.user.emergency2_sub_tel_first;
      this.user.emergency2_sub_tel_middle = res.user.emergency2_sub_tel_middle;
      this.user.emergency2_sub_tel_last = res.user.emergency2_sub_tel_last;
      this.user.emergency2_relationship = res.user.emergency2_relationship;
      this.getUserEnd = true;
    },
    getTodayDate() {
      let today = new Date();
      this.currentYear = today.getFullYear();
      for (let i = 0; i < 70; i++) {
        this.canChoiceBirthYears.push(this.currentYear - i);
      }
      for (let i = 0; i < 2; i++) {
        this.canChoiceYears.push(this.currentYear - i);
      }
      let calcMonth = today.getMonth() + 1;
      let calcDay = today.getDate();
      this.dayCount = new Date(calcMonth, calcDay, 0).getDate();
      this.birthDayCount = new Date(calcMonth, calcDay, 0).getDate();
    },
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    changeCompany() {
      this.user.department_id = "";
      this.user.position_id = "";
      this.user.authority = "";
      this.getDepartment();
      this.getPosition();
    },
    changePosition() {
      let findPosition = this.positions.find(
        position => position.id == this.user.position_id
      );
      this.user.authority = findPosition.default_authority;
    },
    async getDepartment() {
      let data = {
        company_id: this.user.company_id
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentsEnd = true;
    },
    async getPosition() {
      this.getPositionsEnd = false;
      let data = {
        company_id: this.user.company_id
      };
      let res = await this.$store
        .dispatch("GET_POSITION", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.positions = res.positions;
      this.getPositionsEnd = true;
    },
    async editUser() {
      this.user.join_day = this.joinDayFormat;
      this.user.birth_day = this.birthDayFormat;
      let data = this.user;
      let res = await this.$store
        .dispatch("EDIT_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/user" });
      }
    },
    async deleteUser() {
      let res = await this.$store
        .dispatch("DELETE_USER", {
          id: this.$route.params.user_id,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.$router.push({ path: "/user" });
      }
      this.$bvModal.hide("modal-delete");
    },
    getDayCount() {
      this.joinDay = "";
      this.dayCount = new Date(this.joinYear, this.joinMonth, 0).getDate();
    },
    deleteModal(userId) {
      this.deletePositionId = userId;
      this.$bvModal.show("modal-delete");
    },
    getBirthDayCount() {
      this.birthDay = "";
      this.birthDayCount = new Date(
        this.birthYear,
        this.birthMonth,
        0
      ).getDate();
    },
    goUser() {
      this.$router.push({ path: "/user" });
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    }
  }
};
